import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

const ELA_TAXONOMY_ID = "clt5v9pa1000058906kihkg33";
const SOCIAL_STUDIES_TAXONOMY_ID = "clsm7w5t60001cd908iwywkyp";
const SCIENCE_TAXONOMY_ID = "clsm7xcez0001qt90w481x4oj";

export const useTaxonomyConceptsQuery = () => {
  const elaResults = useQuery({
    queryKey: [ApiCatalog.documentViewmodel.key, ELA_TAXONOMY_ID],
    queryFn: () =>
      api().get(`${ApiCatalog.documentViewmodel.endpoint}`, {
        urlReplacers: [{ id: ELA_TAXONOMY_ID }],
      }),
  });

  const sSResults = useQuery({
    queryKey: [ApiCatalog.documentViewmodel.key, SOCIAL_STUDIES_TAXONOMY_ID],
    queryFn: () =>
      api().get(`${ApiCatalog.documentViewmodel.endpoint}`, {
        urlReplacers: [{ id: SOCIAL_STUDIES_TAXONOMY_ID }],
      }),
  });

  const scienceResults = useQuery({
    queryKey: [ApiCatalog.documentViewmodel.key, SCIENCE_TAXONOMY_ID],
    queryFn: () =>
      api().get(`${ApiCatalog.documentViewmodel.endpoint}`, {
        urlReplacers: [{ id: SCIENCE_TAXONOMY_ID }],
      }),
  });

  const isLoading =
    elaResults.isLoading || sSResults.isLoading || scienceResults.isLoading;

  return {
    data: {
      ela: elaResults.data,
      socialStudies: sSResults.data,
      science: scienceResults.data,
    },
    isLoading,
  };
};
